export default __webpack_public_path__ + "static/media/mobile_01.a9ea7d7e.png";